import { type FC, type PropsWithChildren, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';

type ChartCardProps = PropsWithChildren<{
  title?: string;
  description?: string;
  hasChart?: boolean; // NEW
}>;

export const ChartCard: FC<ChartCardProps> = ({
  title,
  description,
  hasChart = true,
  children,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-200 bg-white shadow-lg">
      {/* Header */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-4 px-6 py-3"
      >
        {title ? (
          <h2 className="text-base font-semibold text-gray-800">{title}</h2>
        ) : null}
        {description && (
          <ChevronDownIcon
            className={`size-4 transition-transform ${open ? 'rotate-180' : ''}`}
          />
        )}
      </button>

      {/* Optional Description */}
      {description && open && (
        <p className="px-6 pb-3 text-sm leading-snug text-gray-500">
          {description}
        </p>
      )}

      {/* Content Area */}
      <div className="flex flex-1 items-center justify-center px-2 pb-4">
        {hasChart ? (
          // CHART MODE: fixed aspect ratio to avoid stretching
          <div className="aspect-[4/3] w-full max-w-[420px]">{children}</div>
        ) : (
          // TEXT MODE: allow full vertical centering
          <div className="flex min-h-[260px] w-full items-start justify-center pt-6">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
